// import '../element-variables.scss'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookies from 'vue-cookies'
import elementUi from 'element-ui' // element-ui组件
import locale from '../node_modules/element-ui/lib/locale/lang/en' // element-ui语言库
import Vant from 'vant' // Vant-ui组件
import 'vant/lib/index.css'
import VueI18n from 'vue-i18n'
import {setStore, getStore} from '/utils/storage' // sessionStorage对象
import VueContentPlaceholders from 'vue-content-placeholders'
import VueQuillEditor from 'vue-quill-editor' // 富文本编辑
import consts from '@/utils/consts.js';
import loginApi from '@/api/login.js';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueI18n)
Vue.use(VueQuillEditor)
Vue.use(Vant)
Vue.use(VueContentPlaceholders)
Vue.use(elementUi, {locale})
Vue.use(infiniteScroll)
Vue.use(VueCookies)

// 图片懒加载
Vue.use(VueLazyload, {
  loading: '/static/images/load.gif'
})
Vue.config.productionTip = false

// 多语言
const i18n = new VueI18n({
  locale: 'en',
  messages: {
    ch: require('./common/i18n/lang-ch.json'),
    en: require('./common/i18n/lang-en.json')
  }
})

// 挂载Vue组件
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
})

window.eventBus = new Vue() // 注册全局事件对象

store.commit('SET_WEBSIZDE_USER', null) //


// 过滤白名单
const whiteList1 = ['/login', '/findPass', '/register', '/findPass', '/resetPassword', '/errorPage', '/linkNoActive', '/registerShopping',
  '/orderConfirm', '/orderFail', '/thirdPaying', '/categoryProduct', '/searchProduct', '/moreProduct', '/allProduct','/orderAudit',
  '/allProduct', '/productDetail', '/purchasePolicy', '/privacyPolicy', '/registerPolicy', '/recommendProduct', '/aboutMe',
  '/usregister'] // 白名单列表

// 带*号虚拟白名单（特殊过滤）
const pattPath1 = /\/[1][0-9]{9}/;
const pattPath2 = /\/thirdPayResult.*/;
const pattPath3 = /\/findPassCheck.*/;
const pattPath4 = /\/verifyEmailCheck.*/;

router.beforeEach(function (to, from, next) {
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari

  // 缓存当前路由地址
  if (to.path !== '/user/error') {
    store.commit('SET_ROUTE_PATH', to.path)
  }

  // 根据路由地址判断
  if (whiteList1.indexOf(to.path) === -1 && !(pattPath1.test(to.path) || pattPath2.test(to.path) || pattPath3.test(
      to.path) || pattPath4.test(to.path))) {
    loginApi.checkUser().then(response => {
      if (response.result !== 1) { // 未登录
        store.commit('DELETE_USERINFO') // 清除用户、登录状态数据
        if (to.path === '/home') {
          next()
        } else {
          next('/login')
        }
      } else {
        let userInfo = response.resultMap.user
        let stateUser = store.state.userInfo

        // 更新缓存用户数据
        if (!stateUser || (userInfo.userId != stateUser.userId)) {
          store.commit('RECORD_USERINFO', userInfo)
        }
        if (to.path === '/login') { // 已登录
          next({
            path: '/'
          })
        }
        if (userInfo.status === 20060003 && userInfo.userType === 0) { // 未购物会员-进入购买注册单界面
            let counterPayOrder = response.resultMap.counterPayOrder
            if(counterPayOrder){
              next({
                path: '/orderAudit',
                query:{
                  orderId:counterPayOrder.id
                }
              })
              store.commit('SET_ROUTE_PATH', '/orderAudit')
            }else{
              next({
                path: '/registerShopping'
              })
              store.commit('SET_ROUTE_PATH', '/registerShopping')
            }
        } else {
          next()
        }
      }
    })
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/main.js